module.exports = __webpack_public_path__ + "media/images/pages/i-belong/students-82a8b8611be0d1b8a0ad83c3d36af9c2.jpg";